import React, { useEffect, useState,useCallback } from "react";
import { Link, useLocation } from "react-router-dom";
import debounce from 'lodash/debounce';
const Topbar = () => {
  const location = useLocation();
  const [background, setbackground] = useState("undefined");

  const [isScrolledDown, setIsScrolledDown] = useState(false);
  const [hiddenPropertyMT, sethiddenPropertyMT] = useState(false);
  const [hiddenWhatWeDo, setHiddenWhatWeDo] = useState(false);
  const [hiddenMarketing, setHiddenMarketing] = useState(false);
  const [hiddenCapabilities, setHiddenCapabilities] = useState(false);
  const [hiddenAbout, setHiddenAbout] = useState(false);
  const [isMenuOpen, setMenuOpen] = useState(false);
  // onMouseEnter={() => sethiddenPropertyMT(true)} onMouseLeave={() => sethiddenPropertyMT(false)}
  const toggleMenu = () => {
    setMenuOpen(!isMenuOpen);
  };
  const handleScroll = useCallback(debounce(() => {
    const scrollTop = window.scrollY || document.documentElement.scrollTop;
    setIsScrolledDown(scrollTop > 0);
}, 100), []);
useEffect(() => {
  const isContactUsPage = location.pathname === "/contactus";
  setbackground(isContactUsPage ? "sticky_header" : "undefined");

  window.addEventListener("scroll", handleScroll);
  return () => {
      window.removeEventListener("scroll", handleScroll);
  };
}, [handleScroll, location.pathname]);
  // useEffect(() => {
  //   const isContactUsPage = location.pathname === "/contactus";
  //   setbackground(isContactUsPage ? "sticky_header" : "undefined");

  //   // const handleScroll = () => {
  //   //   const scrollTop = window.scrollY || document.documentElement.scrollTop;
  //   //   if (scrollTop > 0 && !isScrolledDown) {
  //   //     setIsScrolledDown(true);
  //   //   } else if (scrollTop === 0 && isScrolledDown) {
  //   //     setIsScrolledDown(false);
  //   //   }
  //   // };
  //   const handleImageLoad = (e) => {
  //     const target = e.target;
  //     if (target.dataset.mainImage === undefined) return;
  //     if (target.dataset.gatsbyImageSsr === undefined) return;
  //     let wrapper = null;
  //     let node = target;
  //     while (wrapper === null && node) {
  //       if (node.parentNode.dataset.gatsbyImageWrapper !== undefined) {
  //         wrapper = node.parentNode;
  //       }
  //       node = node.parentNode;
  //     }
  //     const placeholderImage = wrapper.querySelector(
  //       "[data-placeholder-image]"
  //     );
  //     const image = new Image();
  //     image.src = target.currentSrc;
  //     image
  //       .decode()
  //       .catch(() => { })
  //       .then(() => {
  //         target.style.opacity = "1";
  //         if (placeholderImage) {
  //           placeholderImage.style.opacity = "0";
  //           placeholderImage.style.transition = "opacity 500ms linear";
  //         }
  //       });
  //   };

  //   document.body.addEventListener("load", handleImageLoad, true);
  //   window.addEventListener("scroll", handleScroll);
  //   return () => {
  //     document.body.removeEventListener("load", handleImageLoad, true);
  //     window.removeEventListener("scroll", handleScroll);
  //   };
  // }, [isScrolledDown, location.pathname]);

  const headerClass = isScrolledDown ? "sticky_header" : "";
  return (
    <header
      className={`${background} ${headerClass} ${isMenuOpen ? "header-module--header_bg--1b37c header_bg" : ""
        }`}
    >
      <div className="container">
        <div className="header-module--header_wrapper--284e1">
          <Link
            aria-current="page"
            className="header_new_logo header-module--header_logo--18f11"
            to={"/"} onClick={() => {
              window.scrollTo(0, 0);
              sethiddenPropertyMT(false)
            }}
          >
            <img
              src="/img/alphai-logo.webp"
              alt="Alphai Solutions"
              width="100"
              height="30"
              loading="lazy"
              className="white-logo"
            />
            <img
              src="/img/alphai-logo-2.svg"
              alt="Alphai Solutions"
              width="100%"
              height="100%"
              className="black-logo"
            />
          </Link>
          <div className="header-module--nav_right--683c1">
            <nav
              className={`header-module--site_navigation--2f0cb ${isMenuOpen ? "active-nav" : ""
                }`}
            >
              <ul className="header-module--site_navigation_listing--b6d34 site_navigation_listing">
                <li>
                  <span className="custom_nav ">
                    <Link to={'/'} className="text-white">
                      Home</Link>


                  </span></li>

                <li onMouseEnter={() => {
                  sethiddenPropertyMT(true)

                }

                } onMouseLeave={() => sethiddenPropertyMT(false)} >
                  <span className="custom_nav">
                    Who we serve
                    <i className="header-module--down_ar--c6a5a">
                      <svg
                        width="12"
                        height="7"
                        viewBox="0 0 12 7"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M5.99844 6.67502C5.88177 6.67502 5.76944 6.65403 5.66144 6.61203C5.55277 6.57069 5.45677 6.50836 5.37344 6.42502L0.873437 1.92502C0.723437 1.77503 0.648438 1.60002 0.648438 1.40002C0.648438 1.20002 0.723437 1.02502 0.873437 0.875025C1.02344 0.725025 1.19844 0.650024 1.39844 0.650024C1.59844 0.650024 1.77344 0.725025 1.92344 0.875025L5.99844 4.95002L10.0734 0.875025C10.2234 0.725025 10.3984 0.650024 10.5984 0.650024C10.7984 0.650024 10.9734 0.725025 11.1234 0.875025C11.2734 1.02502 11.3484 1.20002 11.3484 1.40002C11.3484 1.60002 11.2734 1.77503 11.1234 1.92502L6.62344 6.42502C6.5401 6.50836 6.44444 6.57069 6.33644 6.61203C6.22777 6.65403 6.1151 6.67502 5.99844 6.67502Z"
                          fill="#ffffff"
                        ></path>
                      </svg>
                    </i>
                  </span>
                  <div className="custom_sub_menu header-module--sub_menu--aab9d header-module--what_we_do_menu--86df9" style={{ visibility: hiddenPropertyMT === true ? "visible" : "hidden", opacity: hiddenPropertyMT === true ? "1" : "0" }}>
                    <div className="header-module--sub_menu_wrapper--f732e">
                      <div className="header-module--sub_menu_inner--dc64c">
                        <div className="custom_sub_menu header-module--sub_menu--aab9d header-module--who_we_serve_menu--fae26" style={{ visibility: hiddenPropertyMT === true ? "visible" : "hidden", opacity: hiddenPropertyMT === true ? "1" : "0" }} >
                          <div className="header-module--sub_menu_wrapper--f732e">
                            <div className="header-module--sub_menu_inner--dc64c">
                              <div className="header-module--sub_menu_col_left--7122e">
                                <div className="header-module--sub_menu_listing--0d253">
                                  <div className="header-module--sub_menu_link--2cb3e">
                                    <strong>Who we serve</strong>
                                  </div>
                                </div>
                              </div>
                              <div className="header-module--sub_menu_col_right--bcf2e header-module--serve_sub_menu--bd58e">
                                <div className="header-module--tech_sub_menu_wrap--5969d header-module--industries_sub_wrap--83d8a">
                                  <span className="header-module--heading_text--aaa63">
                                    Type
                                  </span>
                                  <Link
                                    to={"/who-we-serve/startups"} onClick={() => {
                                      window.scrollTo(0, 0);
                                      sethiddenPropertyMT(false)
                                    }}
                                    className="header-module--tech_sub_menu_box--93b56"
                                  >
                                    <div>
                                      <div className="header-module--text_div--0ba0e">
                                        Start ups
                                      </div>
                                    </div>
                                  </Link>
                                  <Link
                                    to={"/who-we-serve/scale-ups"}
                                    onClick={() => {
                                      window.scrollTo(0, 0);
                                      sethiddenPropertyMT(false)
                                    }}
                                    className="header-module--tech_sub_menu_box--93b56"
                                  >
                                    <div>
                                      <div className="header-module--text_div--0ba0e">
                                        <>Scaleups</>
                                      </div>
                                    </div>
                                  </Link>
                                  <Link
                                    to={"/who-we-serve/enterprises"} onClick={() => {
                                      window.scrollTo(0, 0);
                                      sethiddenPropertyMT(false)
                                    }}
                                    className="header-module--tech_sub_menu_box--93b56"
                                  >
                                    <div>
                                      <div className="header-module--text_div--0ba0e">
                                        Enterprises
                                      </div>
                                    </div>
                                  </Link>
                                  <Link
                                    to={"/who-we-serve/it-firms"} onClick={() => {
                                      window.scrollTo(0, 0);
                                      sethiddenPropertyMT(false)
                                    }}
                                    className="header-module--tech_sub_menu_box--93b56"
                                  >
                                    <div>
                                      <div className="header-module--text_div--0ba0e">
                                        NGOs
                                      </div>
                                    </div>
                                  </Link>
                                </div>
                                <div className="header-module--tech_sub_menu_wrap--5969d header-module--industries_sub_wrap--83d8a">
                                  <span className="header-module--heading_text--aaa63">
                                    Industries
                                  </span>
                                  <div className="header-module--inner_menu--506ff">
                                    <div>
                                      <Link
                                        to={"/industries/banking-finance"} onClick={() => {
                                          window.scrollTo(0, 0);
                                          sethiddenPropertyMT(false)
                                        }}
                                        className="header-module--tech_sub_menu_box--93b56"
                                      >
                                        <div>
                                          <div className="header-module--text_div--0ba0e">
                                            Banking &amp; Finance
                                          </div>
                                        </div>
                                      </Link>
                                      <Link
                                        to={"/industries/retail-commerce"} onClick={() => {
                                          window.scrollTo(0, 0);
                                          sethiddenPropertyMT(false)
                                        }}
                                        className="header-module--tech_sub_menu_box--93b56"
                                      >
                                        <div>
                                          <div className="header-module--text_div--0ba0e">
                                            Retail &amp; Commerce
                                          </div>
                                        </div>
                                      </Link>
                                      <Link
                                        to={"/industries/food-beverages"} onClick={() => {
                                          window.scrollTo(0, 0);
                                          sethiddenPropertyMT(false)
                                        }}
                                        className="header-module--tech_sub_menu_box--93b56"
                                      >
                                        <div>
                                          <div className="header-module--text_div--0ba0e">
                                            Food &amp; Beverages
                                          </div>
                                        </div>
                                      </Link>
                                      {/* <Link
                                        to={"/industries/food-and-beverages"} onClick={() => {
                                          window.scrollTo(0, 0);
                                          sethiddenPropertyMT(false)
                                        }}
                                        className="header-module--tech_sub_menu_box--93b56"
                                      >
                                        <div>
                                          <div className="header-module--text_div--0ba0e">
                                            Services
                                          </div>
                                        </div>
                                      </Link> */}
                                    </div>
                                    <div>
                                      <Link
                                        to={"/industries/education"}
                                        onClick={() => {
                                          window.scrollTo(0, 0);
                                          sethiddenPropertyMT(false)
                                        }}
                                        className="header-module--tech_sub_menu_box--93b56"
                                      >
                                        <div>
                                          <div className="header-module--text_div--0ba0e">
                                            Education
                                          </div>
                                        </div>
                                      </Link>
                                      <Link
                                        to={"/industries/healthcare"} onClick={() => {
                                          window.scrollTo(0, 0);
                                          sethiddenPropertyMT(false)
                                        }}
                                        className="header-module--tech_sub_menu_box--93b56"
                                      >
                                        <div>
                                          <div className="header-module--text_div--0ba0e">
                                            Healthcare
                                          </div>
                                        </div>
                                      </Link>
                                      <Link
                                        to={"/industries/social-networking"} onClick={() => {
                                          window.scrollTo(0, 0);
                                          sethiddenPropertyMT(false)
                                        }}
                                        className="header-module--tech_sub_menu_box--93b56"
                                      >
                                        <div>
                                          <div className="header-module--text_div--0ba0e">
                                            Real Estate
                                          </div>
                                        </div>
                                      </Link>
                                      {/* <Link to={'/industries/sports'}
                                      className="header-module--tech_sub_menu_box--93b56"
                                      href="/industries/sports/"
                                    >
                                      <div>
                                        <div
                                          className="header-module--text_div--0ba0e"
                                        >
                                          Sports
                                          
                                        </div>
                                      </div>
                                    </Link> */}
                                    </div>
                                    <div>
                                      <Link
                                        to={
                                          "/industries/travel-hospitality"
                                        } onClick={() => {
                                          window.scrollTo(0, 0);
                                          sethiddenPropertyMT(false)
                                        }}
                                        className="header-module--tech_sub_menu_box--93b56"
                                      >
                                        <div>
                                          <div className="header-module--text_div--0ba0e">
                                            Travel &amp; Hospitality
                                          </div>
                                        </div>
                                      </Link>
                                      <Link
                                        to={
                                          "/industries/supply-chain-logistics"
                                        } onClick={() => {
                                          window.scrollTo(0, 0);
                                          sethiddenPropertyMT(false)
                                        }}
                                        className="header-module--tech_sub_menu_box--93b56"
                                      >
                                        <div>
                                          <div
                                            style={{ whiteSpace: "nowrap" }}
                                            className="header-module--text_div--0ba0e"
                                          >
                                            Supply Chain &amp; Logistics
                                          </div>
                                        </div>
                                      </Link>
                                      {/* <Link
                                        to={
                                          "/industries/supply-chain-and-logistics"
                                        } onClick={() => {
                                          window.scrollTo(0, 0);
                                          sethiddenPropertyMT(false)
                                        }}
                                        className="header-module--tech_sub_menu_box--93b56"
                                      >
                                        <div>
                                          <div
                                            style={{ whiteSpace: "nowrap" }}
                                            className="header-module--text_div--0ba0e"
                                          >
                                            Insurance & Takaful
                                          </div>
                                        </div>
                                      </Link> */}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </li>
                <li onMouseEnter={() => { setHiddenWhatWeDo(true) }} onMouseLeave={() => setHiddenWhatWeDo(false)}>
                  <span className="custom_nav">
                    What we do
                    <i className="header-module--down_ar--c6a5a">
                      <svg
                        width="12"
                        height="7"
                        viewBox="0 0 12 7"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M5.99844 6.67502C5.88177 6.67502 5.76944 6.65403 5.66144 6.61203C5.55277 6.57069 5.45677 6.50836 5.37344 6.42502L0.873437 1.92502C0.723437 1.77503 0.648438 1.60002 0.648438 1.40002C0.648438 1.20002 0.723437 1.02502 0.873437 0.875025C1.02344 0.725025 1.19844 0.650024 1.39844 0.650024C1.59844 0.650024 1.77344 0.725025 1.92344 0.875025L5.99844 4.95002L10.0734 0.875025C10.2234 0.725025 10.3984 0.650024 10.5984 0.650024C10.7984 0.650024 10.9734 0.725025 11.1234 0.875025C11.2734 1.02502 11.3484 1.20002 11.3484 1.40002C11.3484 1.60002 11.2734 1.77503 11.1234 1.92502L6.62344 6.42502C6.5401 6.50836 6.44444 6.57069 6.33644 6.61203C6.22777 6.65403 6.1151 6.67502 5.99844 6.67502Z"
                          fill="#ffffff"
                        ></path>
                      </svg>
                    </i>
                  </span>
                  <div className="custom_sub_menu header-module--sub_menu--aab9d header-module--what_we_do_menu--86df9" style={{ visibility: hiddenWhatWeDo === true ? "visible" : "hidden", opacity: hiddenWhatWeDo === true ? "1" : "0" }}>
                    <div className="header-module--sub_menu_wrapper--f732e">
                      <div className="header-module--sub_menu_inner--dc64c">
                        <div className="custom_sub_menu header-module--sub_menu--aab9d header-module--who_we_serve_menu--fae26" style={{ visibility: hiddenWhatWeDo === true ? "visible" : "hidden", opacity: hiddenWhatWeDo === true ? "1" : "0" }}
                        >
                          <div className="header-module--sub_menu_wrapper--f732e">
                            <div className="header-module--sub_menu_inner--dc64c">
                              <div className="header-module--sub_menu_col_left--7122e">
                                <div className="header-module--sub_menu_listing--0d253">
                                  <div
                                    className="header-module--sub_menu_link--2cb3e"
                                    role="button"
                                  // tabIndex="-13"
                                  >
                                    <strong>What We Do</strong>
                                  </div>
                                </div>
                              </div>
                              <div className="header-module--sub_menu_col_right--bcf2e">
                                <div className="header-module--tech_sub_menu_wrap--5969d">
                                  <a href="/services/product-engineering/" onClick={() => {
                                      window.scrollTo(0, 0);
                                      setHiddenWhatWeDo(false)
                                    }}>
                                    <span className="header-module--heading_text--aaa63">
                                      Product Engineering
                                    </span>
                                  </a>
                                  <Link
                                    className="header-module--tech_sub_menu_box--93b56"
                                    to={"/services/product-engineering/discovery"} onClick={() => {
                                      window.scrollTo(0, 0);
                                      setHiddenWhatWeDo(false)
                                    }}
                                  >
                                    <div>
                                      <div className="header-module--text_div--0ba0e">
                                        Discovery
                                      </div>
                                    </div>
                                  </Link>
                                  <Link
                                    className="header-module--tech_sub_menu_box--93b56"
                                    to={
                                      "/services/product-engineering/ux-ui"
                                    } onClick={() => {
                                      window.scrollTo(0, 0);
                                      setHiddenWhatWeDo(false)
                                    }}
                                  >
                                    <div>
                                      <div className="header-module--text_div--0ba0e">
                                        UX/UI Design
                                      </div>
                                    </div>
                                  </Link>
                                  <Link
                                    className="header-module--tech_sub_menu_box--93b56"
                                    to={
                                      "/services/product-engineering/product-development"
                                    } onClick={() => {
                                      window.scrollTo(0, 0);
                                      setHiddenWhatWeDo(false)
                                    }}
                                  >
                                    <div>
                                      <div className="header-module--text_div--0ba0e">
                                        Product Development
                                      </div>
                                    </div>
                                  </Link>
                                  <Link
                                    className="header-module--tech_sub_menu_box--93b56"
                                    to={
                                      "/services/product-engineering/digital-transformation"
                                    } onClick={() => {
                                      window.scrollTo(0, 0);
                                      setHiddenWhatWeDo(false)
                                    }}
                                  >
                                    <div>
                                      <div className="header-module--text_div--0ba0e">
                                        Digital Transformation
                                      </div>
                                    </div>
                                  </Link>
                                  <Link
                                    className="header-module--tech_sub_menu_box--93b56"
                                    to={
                                      "/services/product-engineering/chatgpt-integration"
                                    } onClick={() => {
                                      window.scrollTo(0, 0);
                                      setHiddenWhatWeDo(false)
                                    }}
                                  >
                                    <div>
                                      <div className="header-module--text_div--0ba0e">
                                        ChatGPT Integration
                                      </div>
                                    </div>
                                  </Link>
                                </div>
                                <div className="header-module--tech_sub_menu_wrap--5969d header-module--tech_sub_wrap--1a2c1">
                                  <Link to='/services/website-development/' style={{ width: "100%" }} onClick={() => {
                                    window.scrollTo(0, 0);
                                    setHiddenWhatWeDo(false)
                                  }}>
                                    <span className="header-module--heading_text--aaa63">
                                      Web Development
                                    </span>
                                  </Link>
                                  <div>
                                    <Link
                                      className="header-module--tech_sub_menu_box--93b56"
                                      to={
                                        "/services/website-development/angular"
                                      } onClick={() => {
                                        window.scrollTo(0, 0);
                                        setHiddenWhatWeDo(false)
                                      }}
                                    >
                                      <div>
                                        <div className="header-module--text_div--0ba0e">
                                          Angular
                                        </div>
                                      </div>
                                    </Link>
                                    <Link
                                      className="header-module--tech_sub_menu_box--93b56"
                                      to={
                                        "/services/website-development/dotnet"
                                      } onClick={() => {
                                        window.scrollTo(0, 0);
                                        setHiddenWhatWeDo(false)
                                      }}
                                    >
                                      <div>
                                        <div className="header-module--text_div--0ba0e">
                                          .Net
                                        </div>
                                      </div>
                                    </Link>
                                    <Link
                                      className="header-module--tech_sub_menu_box--93b56"
                                      to={
                                        "/services/website-development/react"
                                      } onClick={() => {
                                        window.scrollTo(0, 0);
                                        setHiddenWhatWeDo(false)
                                      }}
                                    >
                                      <div>
                                        <div className="header-module--text_div--0ba0e">
                                          React
                                        </div>
                                      </div>
                                    </Link>
                                    <Link
                                      className="header-module--tech_sub_menu_box--93b56"
                                      to={
                                        "/services/website-development/java"
                                      } onClick={() => {
                                        window.scrollTo(0, 0);
                                        setHiddenWhatWeDo(false)
                                      }}
                                    >
                                      <div>
                                        <div className="header-module--text_div--0ba0e">
                                          Java
                                        </div>
                                      </div>
                                    </Link>
                                    <Link
                                      className="header-module--tech_sub_menu_box--93b56"
                                      to={
                                        "/services/website-development/vue"
                                      } onClick={() => {
                                        window.scrollTo(0, 0);
                                        setHiddenWhatWeDo(false)
                                      }}
                                    >
                                      <div>
                                        <div className="header-module--text_div--0ba0e">
                                          Vue
                                        </div>
                                      </div>
                                    </Link>
                                    <Link
                                      className="header-module--tech_sub_menu_box--93b56"
                                      to={
                                        "/services/website-development/python"
                                      } onClick={() => {
                                        window.scrollTo(0, 0);
                                        setHiddenWhatWeDo(false)
                                      }}
                                    >
                                      <div>
                                        <div className="header-module--text_div--0ba0e">
                                          Python
                                        </div>
                                      </div>
                                    </Link>
                                    <Link
                                      className="header-module--tech_sub_menu_box--93b56"
                                      to={
                                        "/services/website-development/node"
                                      } onClick={() => {
                                        window.scrollTo(0, 0);
                                        setHiddenWhatWeDo(false)
                                      }}
                                    >
                                      <div>
                                        <div className="header-module--text_div--0ba0e">
                                          Node
                                        </div>
                                      </div>
                                    </Link>
                                  </div>
                                </div>
                                <div className="header-module--tech_sub_menu_wrap--5969d">
                                  <a href="/services/mobile-app-development/" onClick={() => {
                                    window.scrollTo(0, 0);
                                    setHiddenWhatWeDo(false)
                                  }}>
                                    <span className="header-module--heading_text--aaa63">
                                      Mobile Development
                                    </span>
                                  </a>
                                  <Link
                                    className="header-module--tech_sub_menu_box--93b56"
                                    to={
                                      "/services/mobile-app-development/android"
                                    } onClick={() => {
                                      window.scrollTo(0, 0);
                                      setHiddenWhatWeDo(false)
                                    }}
                                  >
                                    <div>
                                      <div className="header-module--text_div--0ba0e">
                                        Android App Development
                                      </div>
                                    </div>
                                  </Link>
                                  <Link
                                    className="header-module--tech_sub_menu_box--93b56"
                                    to={
                                      "/services/mobile-app-development/ios"
                                    } onClick={() => {
                                      window.scrollTo(0, 0);
                                      setHiddenWhatWeDo(false)
                                    }}
                                  >
                                    <div>
                                      <div className="header-module--text_div--0ba0e">
                                        iOS App Development
                                      </div>
                                    </div>
                                  </Link>
                                  <Link
                                    className="header-module--tech_sub_menu_box--93b56"
                                    to={
                                      "/services/mobile-app-development/react-native"
                                    } onClick={() => {
                                      window.scrollTo(0, 0);
                                      setHiddenWhatWeDo(false)
                                    }}
                                  >
                                    <div>
                                      <div className="header-module--text_div--0ba0e">
                                        React Native
                                      </div>
                                    </div>
                                  </Link>
                                  <Link
                                    className="header-module--tech_sub_menu_box--93b56"
                                    to={
                                      "/services/mobile-app-development/flutter"
                                    } onClick={() => {
                                      window.scrollTo(0, 0);
                                      setHiddenWhatWeDo(false)
                                    }}
                                  >
                                    <div>
                                      <div className="header-module--text_div--0ba0e">
                                        Flutter
                                      </div>
                                    </div>
                                  </Link>
                                </div>
                                <div className="header-module--tech_sub_menu_wrap--5969d">
                                  <Link to={"/services/devops"} onClick={() => {
                                    window.scrollTo(0, 0);
                                    setHiddenWhatWeDo(false)
                                  }}>
                                    <span className="header-module--heading_text--aaa63">
                                      DevOps Solutions
                                    </span>
                                  </Link>
                                  <Link
                                    className="header-module--tech_sub_menu_box--93b56"
                                    to={"/services/devops-consulting"} onClick={() => {
                                      window.scrollTo(0, 0);
                                      setHiddenWhatWeDo(false)
                                    }}
                                  >
                                    <div>
                                      <div className="header-module--text_div--0ba0e">
                                        DevOps Consulting
                                      </div>
                                    </div>
                                  </Link>
                                  <Link
                                    className="header-module--tech_sub_menu_box--93b56"
                                    to={"/services/devops-ci-cd"} onClick={() => {
                                      window.scrollTo(0, 0);
                                      setHiddenWhatWeDo(false)
                                    }}
                                  >
                                    <div>
                                      <div className="header-module--text_div--0ba0e">
                                        CI/CD Development
                                      </div>
                                    </div>
                                  </Link>
                                  <Link
                                    className="header-module--tech_sub_menu_box--93b56"
                                    to={"/services/devops-cloud"} onClick={() => {
                                      window.scrollTo(0, 0);
                                      setHiddenWhatWeDo(false)
                                    }}
                                  >
                                    <div>
                                      <div className="header-module--text_div--0ba0e">
                                        Cloud Engineering
                                      </div>
                                    </div>
                                  </Link>
                                </div>
                                <div className="header-module--tech_sub_menu_wrap--5969d">
                                  <Link to={"/services/quality-assurance-management/"} onClick={() => {
                                    window.scrollTo(0, 0);
                                    setHiddenWhatWeDo(false)
                                  }}>
                                    <span className="header-module--heading_text--aaa63">
                                      QA &amp; Management
                                    </span>
                                  </Link>
                                  <Link
                                    className="header-module--tech_sub_menu_box--93b56"
                                    to={
                                      "/services/quality-assurance"
                                    } onClick={() => {
                                      window.scrollTo(0, 0);
                                      setHiddenWhatWeDo(false)
                                    }}
                                  >
                                    <div>
                                      <div className="header-module--text_div--0ba0e">
                                        Quality Assurance
                                      </div>
                                    </div>
                                  </Link>
                                  <Link
                                    className="header-module--tech_sub_menu_box--93b56"
                                    to={
                                      "/services/product-management"
                                    } onClick={() => {
                                      window.scrollTo(0, 0);
                                      setHiddenWhatWeDo(false)
                                    }}
                                  >
                                    <div>
                                      <div className="header-module--text_div--0ba0e">
                                        Product Management
                                      </div>
                                    </div>
                                  </Link>
                                  <Link
                                    className="header-module--tech_sub_menu_box--93b56"
                                    to={
                                      "/services/project-management"
                                    } onClick={() => {
                                      window.scrollTo(0, 0);
                                      setHiddenWhatWeDo(false)
                                    }}
                                  >
                                    <div>
                                      <div className="header-module--text_div--0ba0e">
                                        Project Management
                                      </div>
                                    </div>
                                  </Link>
                                  <Link
                                    className="header-module--tech_sub_menu_box--93b56"
                                    to={
                                      "/services/app-support-maintenance"
                                    } onClick={() => {
                                      window.scrollTo(0, 0);
                                      setHiddenWhatWeDo(false)
                                    }}
                                  >
                                    <div>
                                      <div className="header-module--text_div--0ba0e">
                                        App Support &amp; Maintenance
                                      </div>
                                    </div>
                                  </Link>
                                  <Link
                                    className="header-module--tech_sub_menu_box--93b56"
                                    to={
                                      "/services/app-modernization"
                                    } onClick={() => {
                                      window.scrollTo(0, 0);
                                      setHiddenWhatWeDo(false)
                                    }}
                                  >
                                    <div>
                                      <div className="header-module--text_div--0ba0e">
                                        App Modernization
                                      </div>
                                    </div>
                                  </Link>
                                </div>
                                <div className="header-module--tech_sub_menu_wrap--5969d">
                                  <Link to={"/talent-solution/"} onClick={() => {
                                    window.scrollTo(0, 0);
                                    setHiddenWhatWeDo(false)
                                  }}>
                                    <span className="header-module--heading_text--aaa63">
                                      Talent Solution
                                    </span>
                                  </Link>
                                  <Link
                                    className="header-module--tech_sub_menu_box--93b56"
                                    to={"/talent-solution/our-team"} onClick={() => {
                                      window.scrollTo(0, 0);
                                      setHiddenWhatWeDo(false)
                                    }}
                                  >
                                    <div>
                                      <div className="header-module--text_div--0ba0e">
                                        Build Your Team
                                      </div>
                                    </div>
                                  </Link>
                                  <Link
                                    className="header-module--tech_sub_menu_box--93b56"
                                    to={"/talent-solution/hire-developer"} onClick={() => {
                                      window.scrollTo(0, 0);
                                      setHiddenWhatWeDo(false)
                                    }}
                                  >
                                    <div>
                                      <div className="header-module--text_div--0ba0e">
                                        Hire Developer
                                      </div>
                                    </div>
                                  </Link>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </li>
                  <li>
                  <span className="custom_nav ">
                    <Link to={'/consultancy'} className="text-white">
                      Consultancy</Link>


                  </span></li>
                <li onMouseEnter={() => { setHiddenMarketing(true) }} onMouseLeave={() => setHiddenMarketing(false)}>
                <span className="custom_nav">
                   {/* Alphai Products */}
                Marketing
                    <i className="header-module--down_ar--c6a5a">
                      <svg
                        width="12"
                        height="7"
                        viewBox="0 0 12 7"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M5.99844 6.67502C5.88177 6.67502 5.76944 6.65403 5.66144 6.61203C5.55277 6.57069 5.45677 6.50836 5.37344 6.42502L0.873437 1.92502C0.723437 1.77503 0.648438 1.60002 0.648438 1.40002C0.648438 1.20002 0.723437 1.02502 0.873437 0.875025C1.02344 0.725025 1.19844 0.650024 1.39844 0.650024C1.59844 0.650024 1.77344 0.725025 1.92344 0.875025L5.99844 4.95002L10.0734 0.875025C10.2234 0.725025 10.3984 0.650024 10.5984 0.650024C10.7984 0.650024 10.9734 0.725025 11.1234 0.875025C11.2734 1.02502 11.3484 1.20002 11.3484 1.40002C11.3484 1.60002 11.2734 1.77503 11.1234 1.92502L6.62344 6.42502C6.5401 6.50836 6.44444 6.57069 6.33644 6.61203C6.22777 6.65403 6.1151 6.67502 5.99844 6.67502Z"
                          fill="#ffffff"
                        ></path>
                      </svg>
                    </i>
                  </span>
                  {/* <span className="custom_nav">
                    <Link className="custom_nav text-white" to={"/resource"} onClick={() => { window.scrollTo(0, 0); }}>
                     
                      Marketing
                    </Link>
                    <i className="header-module--down_ar--c6a5a">
                      <svg
                        width="12"
                        height="7"
                        viewBox="0 0 12 7"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M5.99844 6.67502C5.88177 6.67502 5.76944 6.65403 5.66144 6.61203C5.55277 6.57069 5.45677 6.50836 5.37344 6.42502L0.873437 1.92502C0.723437 1.77503 0.648438 1.60002 0.648438 1.40002C0.648438 1.20002 0.723437 1.02502 0.873437 0.875025C1.02344 0.725025 1.19844 0.650024 1.39844 0.650024C1.59844 0.650024 1.77344 0.725025 1.92344 0.875025L5.99844 4.95002L10.0734 0.875025C10.2234 0.725025 10.3984 0.650024 10.5984 0.650024C10.7984 0.650024 10.9734 0.725025 11.1234 0.875025C11.2734 1.02502 11.3484 1.20002 11.3484 1.40002C11.3484 1.60002 11.2734 1.77503 11.1234 1.92502L6.62344 6.42502C6.5401 6.50836 6.44444 6.57069 6.33644 6.61203C6.22777 6.65403 6.1151 6.67502 5.99844 6.67502Z"
                          fill="#ffffff"
                        ></path>
                      </svg>
                    </i>
                  </span> */}
                  <div className="custom_sub_menu header-module--sub_menu--aab9d header-module--capabilties_menu--e6ed8" style={{ visibility: hiddenMarketing === true ? "visible" : "hidden", opacity: hiddenMarketing === true ? "1" : "0" }}>
                    <div className="header-module--sub_menu_wrapper--f732e">
                      <div className="header-module--sub_menu_inner--dc64c">
                        <div className="custom_sub_menu header-module--sub_menu--aab9d header-module--who_we_serve_menu--fae26" style={{ visibility: hiddenMarketing === true ? "visible" : "hidden", opacity: hiddenMarketing === true ? "1" : "0" }}>
                          <div className="header-module--sub_menu_wrapper--f732e">
                            <div className="header-module--sub_menu_inner--dc64c">
                              <div className="header-module--sub_menu_col_left--7122e">
                                <div className="header-module--sub_menu_listing--0d253">
                                  <div
                                    className="header-module--sub_menu_link--2cb3e"
                                    role="button"
                                  // tabIndex="-20"
                                  >
                                    {/* <strong>Alphai Products</strong> */}
                                    <strong>Marketing</strong>

                                  </div>
                                </div>
                              </div>
                              <div className="header-module--sub_menu_col_right--bcf2e">
                                <div className="header-module--tech_sub_menu_wrap--5969d">
                                  <Link to="/digital-marketing" onClick={() => {
                                    window.scrollTo(0, 0);
                                    setHiddenMarketing(false)
                                  }}>
                                    <span className="header-module--heading_text--aaa63">
                                      {/* Mumtalikati */}
                                      Digital Marketing
                                    </span>
                                  </Link>
                                  <Link onClick={() => {
                                    window.scrollTo(0, 0);
                                    setHiddenMarketing(false)
                                  }}
                                    className="header-module--tech_sub_menu_box--93b56"
                                    to="/digital-marketing/seo"
                                  >
                                    <div>
                                      <div className="header-module--text_div--0ba0e">
                                        SEO
                                      </div>
                                    </div>
                                  </Link>
                                  <Link
                                    className="header-module--tech_sub_menu_box--93b56"
                                    to="/digital-marketing/email" onClick={() => {
                                      window.scrollTo(0, 0);
                                      setHiddenMarketing(false)
                                    }}
                                  >
                                    <div>
                                      <div className="header-module--text_div--0ba0e">
                                        Email Marketing
                                      </div>
                                    </div>
                                  </Link>
                                  <Link
                                    className="header-module--tech_sub_menu_box--93b56"
                                    to="/digital-marketing/content" onClick={() => {
                                      window.scrollTo(0, 0);
                                      setHiddenMarketing(false)
                                    }}
                                  >
                                    <div>
                                      <div className="header-module--text_div--0ba0e">
                                        Content Marketing
                                      </div>
                                    </div>
                                  </Link>
                                </div>
                                <div className="header-module--tech_sub_menu_wrap--5969d">
                                  <Link to="/brand-activation/" onClick={() => {
                                    window.scrollTo(0, 0);
                                    setHiddenMarketing(false)
                                  }} >
                                    <span className="header-module--heading_text--aaa63">
                                      {/* Investi */}
                                      Brand Activation
                                    </span>
                                  </Link>
                                  <Link
                                    className="header-module--tech_sub_menu_box--93b56"
                                    to="/brand-strategy" onClick={() => {
                                      window.scrollTo(0, 0);
                                      setHiddenMarketing(false)
                                    }}
                                  >
                                    <div>
                                      <div className="header-module--text_div--0ba0e">
                                        Brand Strategy
                                      </div>
                                    </div>
                                  </Link>
                                  <Link
                                    className="header-module--tech_sub_menu_box--93b56"
                                    to="/digital-campaigns" onClick={() => {
                                      window.scrollTo(0, 0);
                                      setHiddenMarketing(false)
                                    }}
                                  >
                                    <div>
                                      <div className="header-module--text_div--0ba0e">
                                        Digital campaigns
                                      </div>
                                    </div>
                                  </Link>
                                  <Link
                                    className="header-module--tech_sub_menu_box--93b56"
                                    to="/influencer-collaboration" onClick={() => {
                                      window.scrollTo(0, 0);
                                      setHiddenMarketing(false)
                                    }}
                                  >
                                    <div>
                                      <div className="header-module--text_div--0ba0e">
                                        Influencer collaboration
                                      </div>
                                    </div>
                                  </Link>
                                </div>
                                <div className="header-module--tech_sub_menu_wrap--5969d">
                                  <Link to="/development/" onClick={() => {
                                    window.scrollTo(0, 0);
                                    setHiddenMarketing(false)
                                  }}>
                                    <span className="header-module--heading_text--aaa63">
                                      {/* Alpha Pay */}
                                      Develop
                                    </span>
                                  </Link>

                                  <Link
                                    className="header-module--tech_sub_menu_box--93b56"
                                    to="/website-development" onClick={() => {
                                      window.scrollTo(0, 0);
                                      setHiddenMarketing(false)
                                    }}
                                  >
                                    <div>
                                      <div className="header-module--text_div--0ba0e">
                                        Website Development
                                      </div>
                                    </div>
                                  </Link>
                                  <Link
                                    className="header-module--tech_sub_menu_box--93b56"
                                    to="/mobile-apps-development" onClick={() => {
                                      window.scrollTo(0, 0);
                                      setHiddenMarketing(false)
                                    }}
                                  >
                                    <div>
                                      <div className="header-module--text_div--0ba0e">
                                        Mobile App Development
                                      </div>
                                    </div>
                                  </Link>

                                </div>
                                <div className="header-module--tech_sub_menu_wrap--5969d">
                                  <Link to={`/design/`} onClick={() => {
                                    window.scrollTo(0, 0);
                                    setHiddenMarketing(false)
                                  }}>
                                    <span className="header-module--heading_text--aaa63">
                                      {/* Alpha iBizz */}
                                      Design
                                    </span>
                                  </Link>

                                  <Link
                                    className="header-module--tech_sub_menu_box--93b56"
                                    to="/design/ui-ux" onClick={() => {
                                      window.scrollTo(0, 0);
                                      setHiddenMarketing(false)
                                    }}
                                  >
                                    <div>
                                      <div className="header-module--text_div--0ba0e">
                                        UI/UX Design
                                      </div>
                                    </div>
                                  </Link>
                                  <Link
                                    className="header-module--tech_sub_menu_box--93b56"
                                    to="/design/web" onClick={() => {
                                      window.scrollTo(0, 0);
                                      setHiddenMarketing(false)
                                    }}
                                  >
                                    <div>
                                      <div className="header-module--text_div--0ba0e">
                                        Web Design
                                      </div>
                                    </div>
                                  </Link>
                                  <Link
                                    className="header-module--tech_sub_menu_box--93b56"
                                    to="/design/graphic" onClick={() => {
                                      window.scrollTo(0, 0);
                                      setHiddenMarketing(false)
                                    }}
                                  >
                                    <div>
                                      <div className="header-module--text_div--0ba0e">
                                        Graphic Design
                                      </div>
                                    </div>
                                  </Link>
                                  <Link
                                    className="header-module--tech_sub_menu_box--93b56"
                                    to="/design/animations" onClick={() => {
                                      window.scrollTo(0, 0);
                                      setHiddenMarketing(false)
                                    }}
                                  >
                                    <div>
                                      <div className="header-module--text_div--0ba0e">
                                        2D/3D Animations
                                      </div>
                                    </div>
                                  </Link>
                                </div>
                                {/* <div className="header-module--tech_sub_menu_wrap--5969d">
                                  <Link to={`/design`} onClick={() =>{window.scrollTo(0, 0);
                                       sethiddenPropertyMT(false)} }> 
                                  <span className="header-module--heading_text--aaa63">
                                  AI Chatbot
                                  </span>
                                  </Link>
                                  
                                 
                                </div> */}
                                {/* <div className="header-module--tech_sub_menu_wrap--5969d">
                                  <Link to={`/design`} onClick={() =>{window.scrollTo(0, 0);
                                       sethiddenPropertyMT(false)} }> 
                                  <span className="header-module--heading_text--aaa63">
                                  AI Call Center
                                  </span>
                                  </Link>
                                  
                                 
                                </div> */}
                                {/* <div className="header-module--tech_sub_menu_wrap--5969d">
                                  <Link to={`/design`} onClick={() =>{window.scrollTo(0, 0);
                                       sethiddenPropertyMT(false)} }> 
                                  <span className="header-module--heading_text--aaa63">
                                  iSolvency
                                  </span>
                                  </Link>
                                  
                                 
                                </div> */}
                                {/* <div className="header-module--tech_sub_menu_wrap--5969d">
                                  <Link to={`/design`} onClick={() =>{window.scrollTo(0, 0);
                                       sethiddenPropertyMT(false)} }> 
                                  <span className="header-module--heading_text--aaa63">
                                  Digital Onboarding
                                  </span>
                                  </Link>
                                  
                                 
                                </div> */}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </li>
                <li onMouseEnter={() => { setHiddenCapabilities(true) }} onMouseLeave={() => setHiddenCapabilities(false)}>
                  <span className="custom_nav">
                    Capabilities
                    <i className="header-module--down_ar--c6a5a">
                      <svg
                        width="12"
                        height="7"
                        viewBox="0 0 12 7"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M5.99844 6.67502C5.88177 6.67502 5.76944 6.65403 5.66144 6.61203C5.55277 6.57069 5.45677 6.50836 5.37344 6.42502L0.873437 1.92502C0.723437 1.77503 0.648438 1.60002 0.648438 1.40002C0.648438 1.20002 0.723437 1.02502 0.873437 0.875025C1.02344 0.725025 1.19844 0.650024 1.39844 0.650024C1.59844 0.650024 1.77344 0.725025 1.92344 0.875025L5.99844 4.95002L10.0734 0.875025C10.2234 0.725025 10.3984 0.650024 10.5984 0.650024C10.7984 0.650024 10.9734 0.725025 11.1234 0.875025C11.2734 1.02502 11.3484 1.20002 11.3484 1.40002C11.3484 1.60002 11.2734 1.77503 11.1234 1.92502L6.62344 6.42502C6.5401 6.50836 6.44444 6.57069 6.33644 6.61203C6.22777 6.65403 6.1151 6.67502 5.99844 6.67502Z"
                          fill="#ffffff"
                        ></path>
                      </svg>
                    </i>
                  </span>
                  <div className="custom_sub_menu header-module--sub_menu--aab9d header-module--capabilties_menu--e6ed8" style={{ visibility: hiddenCapabilities === true ? "visible" : "hidden", opacity: hiddenCapabilities === true ? "1" : "0" }}>
                    <div className="header-module--sub_menu_wrapper--f732e">
                      <div className="header-module--sub_menu_inner--dc64c">
                        <div className="custom_sub_menu header-module--sub_menu--aab9d header-module--who_we_serve_menu--fae26" style={{ visibility: hiddenCapabilities === true ? "visible" : "hidden", opacity: hiddenCapabilities === true ? "1" : "0" }}>
                          <div className="header-module--sub_menu_wrapper--f732e">
                            <div className="header-module--sub_menu_inner--dc64c">
                              <div className="header-module--sub_menu_col_left--7122e">
                                <div className="header-module--sub_menu_listing--0d253">
                                  <div
                                    className="header-module--sub_menu_link--2cb3e"
                                    role="button"
                                  // tabIndex="-20"
                                  >
                                    <strong>Capabilities</strong>
                                  </div>
                                </div>
                              </div>
                              <div className="header-module--sub_menu_col_right--bcf2e">
                                <div className="header-module--tech_sub_menu_wrap--5969d header-module--tech_sub_wrap--1a2c1">
                                  <Link to={"/frontend-development/"} onClick={() => {
                                    window.scrollTo(0, 0);
                                    setHiddenCapabilities(false)
                                  }}>
                                    <span className="header-module--heading_text--aaa63">
                                      Front-end
                                    </span>
                                  </Link>
                                  <div>
                                    <Link
                                      className="header-module--tech_sub_menu_box--93b56"
                                      to={"/capabilities/frontend/html-css"} onClick={() => {
                                        window.scrollTo(0, 0);
                                        setHiddenCapabilities(false)
                                      }}
                                    >
                                      <div>
                                        <div className="header-module--text_div--0ba0e">
                                          HTML5/CSS3
                                        </div>
                                      </div>
                                    </Link>
                                    <Link
                                      className="header-module--tech_sub_menu_box--93b56"
                                      to={
                                        "/capabilities/frontend/angular"
                                      } onClick={() => {
                                        window.scrollTo(0, 0);
                                        setHiddenCapabilities(false)
                                      }}
                                    >
                                      <div>
                                        <div className="header-module--text_div--0ba0e">
                                          Angular
                                        </div>
                                      </div>
                                    </Link>
                                    <Link
                                      className="header-module--tech_sub_menu_box--93b56"
                                      to={"/capabilities/frontend/bootstrap"} onClick={() => {
                                        window.scrollTo(0, 0);
                                        setHiddenCapabilities(false)
                                      }}
                                    >
                                      <div>
                                        <div className="header-module--text_div--0ba0e">
                                          Bootstrap
                                        </div>
                                      </div>
                                    </Link>
                                    <Link
                                      className="header-module--tech_sub_menu_box--93b56"
                                      to={
                                        "/capabilities/frontend/react"
                                      } onClick={() => {
                                        window.scrollTo(0, 0);
                                        setHiddenCapabilities(false)
                                      }}
                                    >
                                      <div>
                                        <div className="header-module--text_div--0ba0e">
                                          React
                                        </div>
                                      </div>
                                    </Link>
                                    <Link
                                      className="header-module--tech_sub_menu_box--93b56"
                                      to={
                                        "/capabilities/frontend/vuejs"
                                      } onClick={() => {
                                        window.scrollTo(0, 0);
                                        setHiddenCapabilities(false)
                                      }}
                                    >
                                      <div>
                                        <div className="header-module--text_div--0ba0e">
                                          Vue.js
                                        </div>
                                      </div>
                                    </Link>
                                    <Link
                                      className="header-module--tech_sub_menu_box--93b56"
                                      to={"/capabilities/frontend/javascript"} onClick={() => {
                                        window.scrollTo(0, 0);
                                        setHiddenCapabilities(false)
                                      }}
                                    >
                                      <div>
                                        <div className="header-module--text_div--0ba0e">
                                          JavaScript
                                        </div>
                                      </div>
                                    </Link>
                                    <Link
                                      className="header-module--tech_sub_menu_box--93b56"
                                      to={"/capabilities/frontend/gatsbyjs"} onClick={() => {
                                        window.scrollTo(0, 0);
                                        setHiddenCapabilities(false)
                                      }}
                                    >
                                      <div>
                                        <div className="header-module--text_div--0ba0e">
                                          GatsbyJS
                                        </div>
                                      </div>
                                    </Link>
                                  </div>
                                </div>
                                <div className="header-module--tech_sub_menu_wrap--5969d header-module--tech_sub_wrap--1a2c1">
                                  <Link to={"/backend-development/"} onClick={() => {
                                    window.scrollTo(0, 0);
                                    setHiddenCapabilities(false)
                                  }}>
                                    <span className="header-module--heading_text--aaa63">
                                      Backend
                                    </span>
                                  </Link>
                                  <div>
                                    <Link
                                      className="header-module--tech_sub_menu_box--93b56"
                                      to={
                                        "/capabilities/backend/net"
                                      } onClick={() => {
                                        window.scrollTo(0, 0);
                                        setHiddenCapabilities(false)
                                      }}
                                    >
                                      <div>
                                        <div className="header-module--text_div--0ba0e">
                                          .Net
                                        </div>
                                      </div>
                                    </Link>
                                    <Link
                                      className="header-module--tech_sub_menu_box--93b56"
                                      to={
                                        "/capabilities/backend/nodejs"
                                      } onClick={() => {
                                        window.scrollTo(0, 0);
                                        setHiddenCapabilities(false)
                                      }}
                                    >
                                      <div>
                                        <div className="header-module--text_div--0ba0e">
                                          Node.js
                                        </div>
                                      </div>
                                    </Link>
                                    <Link
                                      className="header-module--tech_sub_menu_box--93b56"
                                      to={
                                        "/capabilities/backend/java"
                                      } onClick={() => {
                                        window.scrollTo(0, 0);
                                        setHiddenCapabilities(false)
                                      }}
                                    >
                                      <div>
                                        <div className="header-module--text_div--0ba0e">
                                          Java
                                        </div>
                                      </div>
                                    </Link>

                                    <Link
                                      aria-current="page"
                                      className="header-module--tech_sub_menu_box--93b56"
                                      to="/" onClick={() => {
                                        window.scrollTo(0, 0);
                                        setHiddenCapabilities(false)
                                      }}
                                    >
                                      <div>
                                        <div className="header-module--text_div--0ba0e"></div>
                                      </div>
                                    </Link>
                                    <Link
                                      className="header-module--tech_sub_menu_box--93b56"
                                      to={
                                        "/capabilities/backend/python"
                                      } onClick={() => {
                                        window.scrollTo(0, 0);
                                        setHiddenCapabilities(false)
                                      }}
                                    >
                                      <div>
                                        <div className="header-module--text_div--0ba0e">
                                          Python
                                        </div>
                                      </div>
                                    </Link>
                                    <Link
                                      aria-current="page"
                                      className="header-module--tech_sub_menu_box--93b56"
                                      to="/" onClick={() => {
                                        window.scrollTo(0, 0);
                                        setHiddenCapabilities(false)
                                      }}
                                    >
                                      <div>
                                        <div className="header-module--text_div--0ba0e"></div>
                                      </div>
                                    </Link>

                                    <Link
                                      aria-current="page"
                                      className="header-module--tech_sub_menu_box--93b56"
                                      to="/" onClick={() => {
                                        window.scrollTo(0, 0);
                                        setHiddenCapabilities(false)
                                      }}
                                    >
                                      <div>
                                        <div className="header-module--text_div--0ba0e"></div>
                                      </div>
                                    </Link>
                                  </div>
                                </div>
                                <div className="header-module--tech_sub_menu_wrap--5969d">
                                  <span className="header-module--heading_text--aaa63">
                                    Trending Tech
                                  </span>
                                  <Link
                                    className="header-module--tech_sub_menu_box--93b56"
                                    to="/capabilities/trending/ai-integration" onClick={() => {
                                      window.scrollTo(0, 0);
                                      setHiddenCapabilities(false)
                                    }}
                                  >
                                    <div>
                                      <div className="header-module--text_div--0ba0e">
                                        AI Integration
                                      </div>
                                    </div>
                                  </Link>
                                  <Link
                                    className="header-module--tech_sub_menu_box--93b56"
                                    to="/capabilities/trending/blockchain" onClick={() => {
                                      window.scrollTo(0, 0);
                                      setHiddenCapabilities(false)
                                    }}
                                  >
                                    <div>
                                      <div className="header-module--text_div--0ba0e">
                                        Blockchain
                                      </div>
                                    </div>
                                  </Link>
                                  <Link
                                    className="header-module--tech_sub_menu_box--93b56"
                                    to="/capabilities/trending/big-data" onClick={() => {
                                      window.scrollTo(0, 0);
                                      setHiddenCapabilities(false)
                                    }}
                                  >
                                    <div>
                                      <div className="header-module--text_div--0ba0e">
                                        Big Data
                                      </div>
                                    </div>
                                  </Link>
                                </div>
                                <div className="header-module--tech_sub_menu_wrap--5969d header-module--tech_sub_wrap--1a2c1">
                                  <Link to="/database-development" onClick={() => {
                                    window.scrollTo(0, 0);
                                    setHiddenCapabilities(false)
                                  }}>
                                    <span className="header-module--heading_text--aaa63">
                                      Database
                                    </span>
                                  </Link>
                                  <div>
                                    <Link
                                      className="header-module--tech_sub_menu_box--93b56"
                                      to="/capabilities/database/sql-server" onClick={() => {
                                        window.scrollTo(0, 0);
                                        setHiddenCapabilities(false)
                                      }}
                                    >
                                      <div>
                                        <div className="header-module--text_div--0ba0e">
                                          SQL Server
                                        </div>
                                      </div>
                                    </Link>
                                    <Link
                                      className="header-module--tech_sub_menu_box--93b56"
                                      to="/capabilities/database/mysql" onClick={() => {
                                        window.scrollTo(0, 0);
                                        setHiddenCapabilities(false)
                                      }}
                                    >
                                      <div>
                                        <div className="header-module--text_div--0ba0e">
                                          MySQL
                                        </div>
                                      </div>
                                    </Link>
                                    <Link
                                      className="header-module--tech_sub_menu_box--93b56"
                                      to="/capabilities/database/firestore" onClick={() => {
                                        window.scrollTo(0, 0);
                                        setHiddenCapabilities(false)
                                      }}
                                    >
                                      <div>
                                        <div className="header-module--text_div--0ba0e">
                                          FIreStore
                                        </div>
                                      </div>
                                    </Link>

                                    <Link
                                      className="header-module--tech_sub_menu_box--93b56"
                                      to="/capabilities/database/mongodb" onClick={() => {
                                        window.scrollTo(0, 0);
                                        setHiddenCapabilities(false)
                                      }}
                                    >
                                      <div>
                                        <div className="header-module--text_div--0ba0e">
                                          MongoDB
                                        </div>
                                      </div>
                                    </Link>

                                    <Link
                                      className="header-module--tech_sub_menu_box--93b56"
                                      to="/capabilities/database/postgresql" onClick={() => {
                                        window.scrollTo(0, 0);
                                        setHiddenCapabilities(false)
                                      }}
                                    >
                                      <div>
                                        <div className="header-module--text_div--0ba0e">
                                          PostgreSQL
                                        </div>
                                      </div>
                                    </Link>
                                  </div>
                                </div>
                                <div className="header-module--tech_sub_menu_wrap--5969d">
                                  <Link to="/cloud-services/" onClick={() => {
                                    window.scrollTo(0, 0);
                                    setHiddenCapabilities(false)
                                  }}>
                                    <span className="header-module--heading_text--aaa63">
                                      Cloud
                                    </span>
                                  </Link>
                                  <Link
                                    className="header-module--tech_sub_menu_box--93b56"
                                    to="/capabilities/cloud/aws" onClick={() => {
                                      window.scrollTo(0, 0);
                                      setHiddenCapabilities(false)
                                    }}
                                  >
                                    <div>
                                      <div className="header-module--text_div--0ba0e">
                                        AWS
                                      </div>
                                    </div>
                                  </Link>
                                  <Link
                                    className="header-module--tech_sub_menu_box--93b56"
                                    to="/capabilities/cloud/azure" onClick={() => {
                                      window.scrollTo(0, 0);
                                      setHiddenCapabilities(false)
                                    }}
                                  >
                                    <div>
                                      <div className="header-module--text_div--0ba0e">
                                        Azure
                                      </div>
                                    </div>
                                  </Link>
                                  <Link
                                    className="header-module--tech_sub_menu_box--93b56"
                                    to="/capabilities/cloud/gcp" onClick={() => {
                                      window.scrollTo(0, 0);
                                      setHiddenCapabilities(false)
                                    }}
                                  >
                                    <div>
                                      <div className="header-module--text_div--0ba0e">
                                        GCP
                                      </div>
                                    </div>
                                  </Link>
                                </div>
                                <div className="header-module--tech_sub_menu_wrap--5969d">
                                  <Link to="/cms-development/" onClick={() => {
                                    window.scrollTo(0, 0);
                                    setHiddenCapabilities(false)
                                  }}>
                                    <span className="header-module--heading_text--aaa63">
                                      CMS
                                    </span>
                                  </Link>
                                  <Link
                                    className="header-module--tech_sub_menu_box--93b56"
                                    to="/capabilities/cms/wordpress" onClick={() => {
                                      window.scrollTo(0, 0);
                                      setHiddenCapabilities(false)
                                    }}
                                  >
                                    <div>
                                      <div className="header-module--text_div--0ba0e">
                                        WordPress
                                      </div>
                                    </div>
                                  </Link>
                                  <Link
                                    className="header-module--tech_sub_menu_box--93b56"
                                    to="/capabilities/cms/jamstack" onClick={() => {
                                      window.scrollTo(0, 0);
                                      setHiddenCapabilities(false)
                                    }}
                                  >
                                    <div>
                                      <div className="header-module--text_div--0ba0e">
                                        JAMStack
                                      </div>
                                    </div>
                                  </Link>
                                  <Link
                                    className="header-module--tech_sub_menu_box--93b56"
                                    to="/capabilities/cms/woocommerce" onClick={() => {
                                      window.scrollTo(0, 0);
                                      setHiddenCapabilities(false)
                                    }}
                                  >
                                    <div>
                                      <div className="header-module--text_div--0ba0e">
                                        WooCommerce
                                      </div>
                                    </div>
                                  </Link>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </li>
                <li
                  onMouseEnter={() => { setHiddenAbout(true) }} onMouseLeave={() => setHiddenAbout(false)}
                >
                  <span className="custom_nav">
                    About
                    <i className="header-module--down_ar--c6a5a">
                      <svg
                        width="12"
                        height="7"
                        viewBox="0 0 12 7"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M5.99844 6.67502C5.88177 6.67502 5.76944 6.65403 5.66144 6.61203C5.55277 6.57069 5.45677 6.50836 5.37344 6.42502L0.873437 1.92502C0.723437 1.77503 0.648438 1.60002 0.648438 1.40002C0.648438 1.20002 0.723437 1.02502 0.873437 0.875025C1.02344 0.725025 1.19844 0.650024 1.39844 0.650024C1.59844 0.650024 1.77344 0.725025 1.92344 0.875025L5.99844 4.95002L10.0734 0.875025C10.2234 0.725025 10.3984 0.650024 10.5984 0.650024C10.7984 0.650024 10.9734 0.725025 11.1234 0.875025C11.2734 1.02502 11.3484 1.20002 11.3484 1.40002C11.3484 1.60002 11.2734 1.77503 11.1234 1.92502L6.62344 6.42502C6.5401 6.50836 6.44444 6.57069 6.33644 6.61203C6.22777 6.65403 6.1151 6.67502 5.99844 6.67502Z"
                          fill="#ffffff"
                        ></path>
                      </svg>
                    </i>
                  </span>
                  <div className="custom_sub_menu header-module--sub_menu--aab9d header-module--about_us_menu--bf4c8" style={{ visibility: hiddenAbout === true ? "visible" : "hidden", opacity: hiddenAbout === true ? "1" : "0" }}>
                    <div className="header-module--sub_menu_wrapper--f732e">
                      <div className="header-module--sub_menu_inner--dc64c">
                        <div className="header-module--about_us_menu_col--035d4">
                          <div className="header-module--about_us_menu_col_inner--2ce1a">
                            <Link to={"/about/our-story"} onClick={() => {
                              window.scrollTo(0, 0);
                              setHiddenAbout(false)
                            }}>
                              <picture>
                                <source
                                  srcSet="/img/Careers.jpeg"
                                  media="(min-width: 150px)"
                                  type="image/webp"
                                />
                                <img
                                  src="/img/Careers.jpeg"
                                  alt="our-story-menu"
                                  loading="lazy"
                                  width="800"  
                                  height="600"
                                  style={{width:"100%",height:"100%"}}
                                />
                              </picture>{" "}
                            </Link>
                            <Link t0={"/about/our-story"} onClick={() => {
                              window.scrollTo(0, 0);
                              setHiddenAbout(false)
                            }}>
                              <strong>Our story</strong>
                            </Link>
                          </div>
                        </div>
                        <div className="header-module--about_us_menu_col--035d4">
                          <div className="header-module--about_us_menu_col_inner--2ce1a">
                            <Link to={"/about/careers"} onClick={() => {
                              window.scrollTo(0, 0);
                              setHiddenAbout(false)
                            }}>
                              <picture>
                                <source
                                  srcSet="/img/our-story.png"
                                  media="(min-width: 150px)"
                                  type="image/webp"
                                />
                                <img
                                  src="/img/our-story.png"
                                  alt="career-menu"
                                  loading="lazy"
                                  width="100%"
                                  height="100%"
                                />
                              </picture>{" "}
                            </Link>
                            <Link to={"/about/careers"} onClick={() => {
                              window.scrollTo(0, 0);
                              setHiddenAbout(false)
                            }}>
                              <strong>Careers</strong>
                            </Link>
                          </div>
                        </div>
                        <div className="header-module--about_us_menu_col--035d4">
                          <div className="header-module--about_us_menu_col_inner--2ce1a">
                            <Link to={"/about/life-at-alphai"} onClick={() => {
                              window.scrollTo(0, 0);
                              setHiddenAbout(false)
                            }}>
                              <picture>
                                <source
                                  srcSet="/img/lifealphai.jpg"
                                  media="(min-width: 150px)"
                                  type="image/webp"
                                />
                                <img
                                  src="/img/lifealphai.jpg"
                                  alt="life-agile-menu"
                                  loading="lazy"
                                  width="100%"
                                  height="100%"
                                />
                              </picture>{" "}
                            </Link>
                            <Link to={"/about/life-at-alphai"} onClick={() => {
                              window.scrollTo(0, 0);
                              setHiddenAbout(false)
                            }}>
                              <strong>Life at Alphai</strong>
                            </Link>
                          </div>
                        </div>
                        <div className="header-module--about_us_menu_col--035d4">
                          <div className="header-module--about_us_menu_col_inner--2ce1a">
                            <Link to={"/about/engagement-models"} onClick={() => {
                              window.scrollTo(0, 0);
                              setHiddenAbout(false)
                            }}>
                              <picture>
                                <source
                                  srcSet="/img/Engagementmodels.jpg"
                                  media="(min-width: 150px)"
                                  type="image/webp"
                                />
                                <img
                                  src="/img/Engagementmodels.jpg"
                                  alt="career-menu"
                                  loading="lazy"
                                  width="100%"
                                  height="100%"
                                />
                              </picture>{" "}
                            </Link>
                            <Link to={"/about/engagement-models"} onClick={() => {
                              window.scrollTo(0, 0);
                              setHiddenAbout(false)
                            }}>
                              <strong>Engagement models</strong>
                            </Link>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </li>

              </ul>
            </nav>
            <div
              className={`toggle_menu ${isMenuOpen ? "active" : ""}`}
              role="button"
              tabIndex="-24"
              onClick={toggleMenu}
            >
              <div className="bar1"></div>
              <div className="bar2"></div>
              <div className="bar3"></div>
            </div>
            <Link
              className="linkButtonRed-module--btn_red--0ea81 header-btn"
              to="/contactus" onClick={() => {
                window.scrollTo(0, 0);
                sethiddenPropertyMT(false)
              }}
            >
              Get Started
            </Link>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Topbar;
